import brand from './brand.json';
import logo from './logo.svg';
import illustration from './illustration.svg';
import { ReactComponent as Icon } from './icon.svg';

export default { ...brand, logo, illustration, Icon };
